export default __webpack_public_path__ + "static/media/cp_geo_pe.e7a9389a.svg";